import * as pdfjsLib from "pdfjs-dist";

const pdf2Images = async (url) => {
    const pdf = await pdfjsLib.getDocument(url).promise;
    const images = [];

    for (let i = 1; i <= pdf.numPages; i++) {
        const page = await pdf.getPage(i);
        const viewport = page.getViewport({scale: 1.5});

        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');
        canvas.height = viewport.height;
        canvas.width = viewport.width;

        await page.render({
            canvasContext: context,
            viewport: viewport
        }).promise;

        images.push(canvas.toDataURL('image/png'));
    }

    return images;
};

export default pdf2Images;
